// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"0c989746","43":"3727b762","98":"51366e0c","127":"e7e81892","381":"96174585","892":"cbc10e4b","915":"1ee6e370","950":"78ccf31c","987":"2238a907"}[chunkId] + ".chunk.js";
};